import {SESSION_STORAGE_KEYS} from "../constants/js-constants.es6.js";
import SessionStorageUtils from "../utils/session-storage-utils.es6.js";

export const NUMBER_OF_SECONDS_BEFORE_APPOINTMENT_TIME_TO_ALLOW_VISIT_LAUNCH = 30;

export default class VirtualUrgentCareRedirectUtils {
  /**
   * Redirect the user to the correct virtual urgent care page depending on
   * whether or not they have an active virtual urgent care session and if the
   * virtual urgent care service is currently accepting patients.
   */
  static async redirect({
    luminisServiceUtils,
    closedPageUrl,
    openPageUrl,
    inQueuePageUrl,
    launchVisitPageUrl,
  }) {
    let redirectPathname;

    const virtualUrgentCareSession = await VirtualUrgentCareRedirectUtils.#getVirtualUrgentCareSession(
      luminisServiceUtils,
    );

    if (virtualUrgentCareSession) {
      const slot = new Date(virtualUrgentCareSession.appointment.slot);
      const estimatedWaitTimeSeconds = VirtualUrgentCareRedirectUtils.#calculateEstimatedWaitTimeSeconds(
        slot,
      );

      if (
        estimatedWaitTimeSeconds <=
        NUMBER_OF_SECONDS_BEFORE_APPOINTMENT_TIME_TO_ALLOW_VISIT_LAUNCH
      ) {
        redirectPathname = launchVisitPageUrl;
      } else {
        redirectPathname = inQueuePageUrl;
      }
    } else {
      const acceptingPatients = await VirtualUrgentCareRedirectUtils.#acceptingPatients(
        luminisServiceUtils,
      );

      if (acceptingPatients) {
        redirectPathname = openPageUrl;
      } else {
        redirectPathname = closedPageUrl;
      }
    }

    if (!redirectPathname) {
      return;
    }

    const currentPathname = window.location.pathname;
    if (redirectPathname !== currentPathname) {
      window.location.href = redirectPathname;
    }
  }

  static async #getVirtualUrgentCareSession(luminisServiceUtils) {
    const virtualUrgentCareSessionId = SessionStorageUtils.getItem(
      SESSION_STORAGE_KEYS.VIRTUAL_URGENT_CARE_SESSION_ID,
    );

    if (virtualUrgentCareSessionId) {
      return await luminisServiceUtils.getVirtualUrgentCareSession(
        virtualUrgentCareSessionId,
      );
    }
  }

  static async #acceptingPatients(luminisServiceUtils) {
    const acceptingPatients = await luminisServiceUtils.getVirtualUrgentCareAcceptingPatients();
    if (acceptingPatients) {
      return acceptingPatients;
    } else {
      return false;
    }
  }

  static #calculateEstimatedWaitTimeSeconds(appointmentDateTime) {
    if (!(appointmentDateTime instanceof Date)) {
      throw new TypeError('AppointmentDateTime must be an instance of a Date.');
    }

    const now = new Date();
    if (appointmentDateTime <= now) {
      return 0;
    }

    return (appointmentDateTime - now) / 1000;
  }
}
